import {inject, Injectable, signal, Signal} from '@angular/core';
import {SchemeService} from '../data/scheme.service';
import {toObservable, toSignal} from '@angular/core/rxjs-interop';
import {Scheme} from '../domain/scheme.model';
import {switchMap} from 'rxjs';

@Injectable({providedIn: 'root'})
export class SchemeFacade {
  private readonly _schemeService = inject(SchemeService);

  private readonly _schematicId = signal<string>('4743246');

  private readonly _scheme = toSignal(
    toObservable(this._schematicId).pipe(
      switchMap(id => this._schemeService.getScheme(id))
    )
  );

  public readonly scheme: Signal<Scheme | undefined> = this._scheme;
}
